import React from 'react';

import { KnpPaginationData, User } from 'app/model';
import { Formatters } from 'app/utils/formatters';

import { DelayedSearch } from './delayed-search';
import { GeneralConstants } from '../constants/general-constants';
import { userService } from '../services/user.service';

interface UserPickerProps {
    value?: User;
    label?: string;
    size?: 'medium' | 'small';
    className?: string;
    variant?: 'filled' | 'outlined' | 'standard';
    onChange: (event: React.ChangeEvent<unknown>, value?: User) => void;
    helperText?: string;
}

export class UserPicker extends React.Component<UserPickerProps> {
    public render(): React.ReactNode {
        return (
            <DelayedSearch
                {...this.props}
                freeSolo={false}
                value={this.props.value || GeneralConstants.COMPONENT_VALUE_NULL}
                label={this.props.label || 'Pick A User'}
                onSearch={(search) => userService.list({ queryFilters: { search } })}
                mapDataToOptions={(data: KnpPaginationData<User>) => data.data}
                getOptionLabel={Formatters.userDisplayName}
                isOptionEqualToValue={(option, value) => option.id === value.id}
            />
        );
    }
}
